/**
 * Copyright 2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

export const azureRegions = [
  "australiacentral",
  "australiacentral2",
  "australiaeast",
  "australiasoutheast",
  "austriaeast",
  "belgiumcentral",
  "brazilsouth",
  "brazilsoutheast",
  "canadacentral",
  "canadaeast",
  "centralindia",
  "centralus",
  "chilecentral",
  "denmarkeast",
  "eastasia",
  "eastus",
  "eastus2",
  "francecentral",
  "francesouth",
  "germanynorth",
  "germanywestcentral",
  "indonesiacentral",
  "israelcentral",
  "italynorth",
  "japaneast",
  "japanwest",
  "jioindiawest",
  "koreacentral",
  "koreasouth",
  "malaysiawest",
  "mexicocentral",
  "newzealandnorth",
  "northcentralus",
  "northeurope",
  "norwayeast",
  "norwaywest",
  "polandcentral",
  "qatarcentral",
  "southafricanorth",
  "southafricawest",
  "southcentralus",
  "southeastasia",
  "southindia",
  "spaincentral",
  "swedencentral",
  "switzerlandnorth",
  "switzerlandwest",
  "uaecentral",
  "uaenorth",
  "uksouth",
  "ukwest",
  "westcentralus",
  "westeurope",
  "westindia",
  "westus",
  "westus2",
  "westus3",
];

export const azureRegionsOptions = azureRegions.map((region) => ({
  value: region,
  label: region,
}));
